import { Outlet } from "react-router";
import Header from "components/navigation/Header";
import Footer from "components/footer/Footer";

export default function Layout(){
  return(
    <div>
      <Header/>
      <div className="absolute inset-x-0 top-0 z-0">
        <div className="relative">
          <Outlet/>
        </div>
        <Footer className="relative"/>
      </div>
      </div>
  );
}